var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"floatMenu",class:[
        _vm.mouse_clicked ? 'float-down' : '',
        'float-menu bg-primary w-14 h-14 text-black border-black border'
    ],style:(_vm.elementStyle)},[_c('div',{staticClass:"flex justify-center content-center h-full"},[_c('unicon',{staticClass:"self-center",attrs:{"name":"shopping-cart","fill":"#000000"}}),_c('span',{staticClass:"text-xs absolute right-2 top-2",domProps:{"innerHTML":_vm._s(_vm.cartProductsLength)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }